import { Image, Typography } from 'antd';
import React, { useContext, useState, useEffect } from 'react';
import ThemeContext from 'store/ThemeContext';
import packageJson from '../../package.json';

/**
 * 앱 Copyright
 * @param {object} styles css
 * @returns ReactNode
 */
function AppCopyright({ styles }) {
  const [customCopyright, setCustomCopyright] = useState(null);
  const theme = useContext(ThemeContext);
  const [siteName] = useState(packageJson.config?.preid || undefined); // 사이트 네임

  // 만약 커스텀된 copyright이 image면 리소스를 가져온다.
  // Warning: Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function.
  useEffect(() => {
    if (theme.copyright.type === 'image') {
      (async () => {
        const resource = await import(`images/${theme.copyright.value}`);
        setCustomCopyright(resource.default);
      })();
    }
    return () => {
      // setCustomCopyright(null);
    };
  }, []);

  return (
    <>
      {siteName === 'lgd' && (
        <Typography.Paragraph>
          <div style={{ fontWeight: 500 }}>IT 서비스 데스크 안내</div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
            <span>
              <span style={{ color: '#c00c3f' }}>(사내)</span> 8272-3999,
            </span>
            <span>
              <span style={{ color: '#c00c3f' }}>(사외)</span> 1544-3999
            </span>
          </div>
        </Typography.Paragraph>
      )}
      {theme.copyright.type === 'string' ? (
        <Typography.Paragraph type="secondary" style={styles}>
          {theme.copyright.value}
        </Typography.Paragraph>
      ) : (
        <Image src={customCopyright} preview={false} style={styles} />
      )}
    </>
  );
}

export default AppCopyright;
